import axios from 'axios';
import { apiBaseUrl } from '../config';

const adminHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` }, withCredentials: true });

// Public tools catalog (active tools only)
export const listTools = () => axios.get(`${apiBaseUrl}/tools`);

export const adminListTools = (token) =>
  axios.get(`${apiBaseUrl}/admin/tools/list`, adminHeaders(token));

export const adminGetTool = (token, id) =>
  axios.get(`${apiBaseUrl}/admin/tools/${id}`, adminHeaders(token));

export const adminUpdateTool = (token, id, data) =>
  axios.put(`${apiBaseUrl}/admin/tools/${id}`, data, adminHeaders(token));

export const adminDeleteTool = (token, id) =>
  axios.delete(`${apiBaseUrl}/admin/tools/${id}`, adminHeaders(token));
